// Mirrors Roadproof.Services.Values.IncidentType - see there before changing these numbers.
export enum IncidentType {
  None = 0,
  IncidentAccident = 1,
  IncidentAftermath = 3,
  IncidentOther = 5
}

export enum ReviewStatus
{
    PendingEvaluation = 0, // If the video isn't in a review queue, pending also means "Not even in the review queue"
    NoIncident = 1,
    Incident = 2
}


interface FindFootageResponse {
  footage: Footage[];
  cameras: Camera[];
}

export interface Camera {
  camera_id: number;
  label: string;
  width: number;
  height: number;
  jurisdiction: string;
  lat: number;
  lng: number;
  distance_meters?: number;
  isSelected: boolean;
  isHighlighted: boolean;
}

export interface Footage {
  footage_id: number;
  camera_id: number;
  camera?: Camera;
  thumbnail_url: string;
  timelapse_url: string;
  video_url: string;
  archive_url: string;
  distance_meters: number;
  review_status: ReviewStatus;
  incident_type: IncidentType;
  reviewed_date_utc: string;
  reviewed_notes: string;
  user_downloaded: boolean;
  file_size: number;
  nearby_incidents: any[];
  metadata: Metadata[];
  camera_type: number;
  start_date_utc: string;
  end_date_utc: string;
  timezone_local: string;
  start_date_local: string;
  end_date_local: string;
  notes: string;
  when: string;
  duration: string;
  width: string;
  height: string;
  fps?: string;
  refresh?: string;
  timezone: string
}

interface Metadata {
  key: string;
  label: string;
  value: string;
}

export async function getFootage(lat: number, lng: number, datetimeLocal, timezone: string, radius: number, hoursInterval: number): Promise<FindFootageResponse> {
  const url = `/WebAPI/FindFootage?lat=${lat}&lng=${lng}&datetime=${datetimeLocal}&timezone=${timezone}&searchRadiusMiles=${radius || 1}&hoursInterval=${hoursInterval || 1}`;
  const response = await fetch(url);
  const data = await response.json();
  return data;
}

export interface ReviewFootageInput {
  footage_id: number,
  review_status: ReviewStatus,
  incident_type: IncidentType,
  reviewed_notes: string,
}

export async function reviewFootage(input: ReviewFootageInput) {

  const requestBody = {
    input: input,
  }
  const url = `/WebAPI/ReviewFootage`;
  const response = await fetch(url, {
    method: "POST",
    body: JSON.stringify(input),
    headers: {
      "Content-Type": "application/json",
    },
  });
  
  const data = await response.json();
  return data;
}